import React from 'react';
import PropTypes from 'prop-types';
import { Row } from '../../structure/row';
import { Cell, LEFT, RIGHT } from '../../structure/cell';
import { FormattedPrice } from '../../../price/formatted_price';
import { Translation } from '../../../translation/translation';

export const ServiceFitting = ({
    quantity,
    currencyIsoCode,
    fittingPrice,
    loading,
}) => (
    <Row className="service-fitting" isSub={true}>
        <Cell colSpan={2} side={LEFT}>
            <Translation
                className="product-set-price__headline"
                translationKey={
                    quantity > 1
                        ? 'pdp-sidebar-service-fitting-label'
                        : 'pdp-sidebar-service-fitting-label-single-item'
                }
                placeholder={{ quantity }}
            />
        </Cell>
        <Cell colSpan={2} side={RIGHT}>
            <FormattedPrice
                price={fittingPrice}
                currencyIsoCode={currencyIsoCode}
                className="product-set-price__price"
                loading={loading}
                inCents={true}
            />
        </Cell>
    </Row>
);

ServiceFitting.propTypes = {
    quantity: PropTypes.number.isRequired,
    fittingPrice: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
};
